import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FileRequest } from '../../models/file.model';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  private readonly API = `${environment.api_url}/arquivo`;

  constructor(private http: HttpClient) {}

  save(request: FileRequest): Observable<void[]> {
    return this.http.post<void[]>(`${this.API}`, request);
  }

  getAssetsFile(
    path: string,
    responseType: string,
    contentType: string
  ): Observable<unknown> {
    return this.http.get<unknown>(path, {
      headers: new HttpHeaders({
        'Content-Type': contentType,
        responseType: responseType,
      }),
      responseType: responseType as 'json',
    });
  }
}
